import React, { memo } from 'react';
import { AnimatedSection } from './AnimatedSection';
export function PortfolioSection() {
  const events = [{
    title: 'Venture Capital Conference',
    category: 'Corporate Conference',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/orWC7haFg2e4AXdavNKTgR/1726242014582_%281%29.jpg'
  }, {
    title: 'Hersh Wedding',
    category: 'Wedding',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oBMPduE4hKmwUGQ1cbQiXj/240817_HK_1457.jpg'
  }, {
    title: 'Tesseral Product Launch',
    category: 'Corporate',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/camETUgFkTYYwDH5ucD9ZM/1750180921577.jpg'
  }];
  return <section id="portfolio" className="py-16 bg-white" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <AnimatedSection data-id="element-190">
          <div className="text-center mb-12" data-id="element-191">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-192">
              Our Portfolio
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-193">
              A showcase of our most successful and memorable events.
            </p>
          </div>
        </AnimatedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-194">
          {events.map((event, index) => <AnimatedSection key={index} delay={index * 0.2} data-id="element-195">
              <div className="group relative overflow-hidden rounded-lg shadow-md" data-id="element-196">
                <div className="h-64 w-full overflow-hidden" data-id="element-197">
                  <img src={event.image} alt={event.title} className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${event.title === 'Tesseral Product Launch' ? 'object-center' : 'object-center'}`} style={event.title === 'Tesseral Product Launch' ? {
                objectPosition: 'center 70%'
              } : {}} data-id="element-198" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex flex-col justify-end p-6 text-white" data-id="element-199">
                  <p className="text-sm font-medium text-indigo-300 mb-1" data-id="element-200">
                    {event.category}
                  </p>
                  <h3 className="text-xl font-bold" data-id="element-201">{event.title}</h3>
                </div>
              </div>
            </AnimatedSection>)}
        </div>
        <AnimatedSection delay={0.6} data-id="element-202">
          <div className="mt-12 text-center" data-id="element-203">
            <a href="https://calendly.com/dan-the-academi/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition-colors duration-300" data-id="element-204">
              Let's Plan Your Event
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}